import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { StepId, STEPS } from './constants';

interface Props {
  currentStep: StepId;
  onStepChange: (step: StepId) => void;
  hasStarted: boolean;
}

export default function Sidebar({ currentStep, onStepChange, hasStarted }: Props) {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    if (hasStarted) {
      const confirmed = window.confirm(
        'Your progress will be permanently lost when you leave this page. All data will be cleared. Are you sure you want to continue?'
      );
      if (!confirmed) return;
    }
    navigate('/');
  };

  return (
    <div className="h-screen sticky top-0 bg-white p-4 space-y-2">
      <button
        onClick={handleLogoClick}
        className="flex items-center gap-3 px-4 py-3 mb-6 hover:bg-gray-50 rounded-lg transition-colors w-full"
      >
        <FileText className="h-6 w-6 text-teal-600" />
        <span className="text-lg font-semibold text-gray-900">Make Resume Free</span>
      </button>

      {STEPS.map((step, index) => {
        const isActive = currentStep === step.id;
        const isPast = STEPS.findIndex(s => s.id === currentStep) > index;

        return (
          <button
            key={step.id}
            onClick={() => onStepChange(step.id)}
            className={`
              w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-colors
              ${isActive 
                ? 'bg-teal-600 text-white' 
                : isPast
                  ? 'bg-teal-50 text-teal-600'
                  : 'text-gray-600 hover:bg-gray-50'
              }
            `}
          >
            <span className="font-medium">{step.title}</span>
          </button>
        );
      })}
    </div>
  );
}